import styled from '@emotion/styled'
import clsx from 'clsx'
import { Fragment, ReactNode } from 'react'
import { ClassName } from 'types/props'

import { Rule, Space } from '../..'
import classes from './index.module.scss'

const SpacingMap = {
  sm: '16px',
  md: '20px',
  lg: '24px'
}
const StyledSimpleTabHeader = styled.div<{ spacing: 'sm' | 'md' | 'lg' }>`
  color: var(--Graphite);
  div,
  ul,
  li,
  button {
    margin: 0;
    padding: 0;
    font-weight: normal;
    background: var(--Transparent);
    white-space: nowrap;
  }
  ul {
    display: flex;
  }
  ul > li {
    list-style: none;
    flex-direction: column;
  }
  ul > li > button {
    padding: 12px 12px ${props => SpacingMap[props.spacing]};
    label > button {
      text-align: left;
      white-space: nowrap;
    }
    label > button > svg {
      width: 20px;
      height: 20px;
    }
    label > button > div {
      color: inherit;
      width: auto;
    }
    label > button > span {
      padding-left: 6px;
    }
  }
`

interface Props extends ClassName {
  ['aria-label']?: string
  children: ReactNode | ReactNode[]
  ruleClassName?: string
  showRule?: boolean
  spacing?: 'sm' | 'md' | 'lg'
}

export const SimpleTabStrip = ({
  children,
  className,
  ruleClassName,
  showRule = true,
  spacing = 'lg',
  ...props
}: Props) => {
  // TODO: Change this to React.Children
  // see: https://reactjs.org/docs/react-api.html#reactchildren
  const childrenElems = Array.isArray(children) ? children : [children]

  return (
    <>
      <StyledSimpleTabHeader className={className} role="tablist" spacing={spacing} {...props}>
        <Space isflex flexDirection="row" mt={6} mx={5}>
          <ul>
            {childrenElems.map((child, i) => {
              if (child) {
                // eslint-disable-next-line react/no-array-index-key
                return <li key={i}>{child}</li>
              }
              // eslint-disable-next-line react/no-array-index-key
              return <Fragment key={i} />
            })}
          </ul>
        </Space>
      </StyledSimpleTabHeader>
      {showRule && <Rule className={clsx(ruleClassName, classes.rule)} />}
    </>
  )
}
